import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  QueryNewNotificationsRequest,
  ViewAllNotificationsRequest,
  ViewNewNotificationsRequest
} from './notification.types';

export const requestViewAllNotifications =
  createAction<SagaPayload<ViewAllNotificationsRequest>['payload']>('request/viewAllNotifications');

export const requestQueryNewNotifications = createAction<SagaPayload<QueryNewNotificationsRequest, boolean>['payload']>(
  'request/queryNewNotifications'
);
export const requestViewNewNotifications =
  createAction<SagaPayload<ViewNewNotificationsRequest>['payload']>('request/viewNewNotifications');
